import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell, Check, Flame } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import {
  subscribeNotifications,
  markNotificationRead,
} from "../../services/collavueStore";
import PageHeader from "../../components/collavue/PageHeader";
import Empty from "../../components/collavue/Empty";

export default function NotificationsPage() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!user) return;
    return subscribeNotifications(setItems);
  }, [user]);

  return (
    <div className="max-w-3xl mx-auto p-4 sm:p-6">
      <PageHeader
        title="Notifications"
        subtitle="Hot leads, sync results, and credit alerts."
      />
      {items.length === 0 ? (
        <Empty
          icon={Bell}
          title="No notifications yet"
          body="You'll be notified when sync finds a hot lead or when credits run low."
        />
      ) : (
        <ul className="space-y-2">
          {items.map((n) => (
            <li
              key={n.id}
              className={`bg-white border rounded-xl p-4 flex items-start gap-3 ${
                n.read ? "border-slate-200" : "border-indigo-200 ring-1 ring-indigo-100"
              }`}
            >
              <div className="w-9 h-9 rounded-full bg-indigo-50 text-indigo-600 flex items-center justify-center shrink-0">
                {n.type === "hot_lead" ? (
                  <Flame className="w-4 h-4" />
                ) : (
                  <Bell className="w-4 h-4" />
                )}
              </div>
              <div className="min-w-0 flex-1">
                <div className="font-semibold">{n.title}</div>
                <div className="text-sm text-slate-600">{n.body}</div>
                <div className="text-xs text-slate-400 mt-1">
                  {n.createdAt?.toDate
                    ? n.createdAt.toDate().toLocaleString()
                    : ""}
                </div>
                <div className="mt-2 flex items-center gap-3 text-sm">
                  {n.campaignId && (
                    <Link
                      to={`/leads?campaignId=${n.campaignId}`}
                      className="text-indigo-600 hover:underline"
                    >
                      View leads →
                    </Link>
                  )}
                  {!n.read && (
                    <button
                      onClick={() => markNotificationRead(n.id)}
                      className="text-slate-500 hover:text-slate-900 inline-flex items-center gap-1"
                    >
                      <Check className="w-3.5 h-3.5" /> Mark read
                    </button>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
